export enum SpecialElementType {
    None,
    CalculatedElement,
    EmptyElement,
    Variable
}